/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CohortStateProperty } from './cohortStateProperty';
import type { CohortStateChangedAt } from './cohortStateChangedAt';

/**
 * Representation of a cohort
 */
export interface Cohort {
  id: string;
  title: string;
  state?: CohortStateProperty;
  isDeprecated?: boolean;
  stateChangedAt?: CohortStateChangedAt;
}
